module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "btn-group",
    class: {
      'active': _vm.isActive
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleClick($event)
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_c('i', {
    staticClass: "fa fa-check text-active"
  }), _vm._v(" " + _vm._s(_vm.label) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-512937b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/Uloc/button/UButtonGroupItem.vue
// module id = 1857
// module chunks = 18